/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TabelaPrecoAliases {
  AUTOCOMPLETE_TABELA_PRECO_PRODUTO = 'autocomplete-tabela-preco-produto',
  DECK_TABELA_PRECO = 'deck-tabela-preco',
  DECK_TABELA_PRECO_MOBILE = 'deck-tabela-preco-mobile',
  FETCH_FILTER_PRODUTOS = 'fetch-filter-produtos',
  FETCH_TABELA_PRECO = 'fetch-tabela-preco',
  FIELD_023423 = 'field-023423',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_TABELA_PRECO_0 = 'hpms-tabela-preco-0',
  HPMS_TABELA_PRECO_MOBILE = 'hpms-tabela-preco-mobile',
  LAYOUT_TABELA_PRECO = 'layout-tabela-preco',
  MAPPER_0 = 'mapper-0',
  MEDIA_QUERY = 'media-query',
  MEDIA_QUERY_MOBILE = 'media-query-mobile',
  PANEL_0 = 'panel-0',
  TEXT_0 = 'text-0',
}
export { TabelaPrecoAliases };
